import React from 'react';
import CCMRSSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CourseDescription from '../../../components/courseDescription';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBG from '../../../images/ComponentImages/categoryScreenBackground.png';
import ItemGrid from '../../../components/itemGrid';
import WarningBlock from '../../../components/warningBlock';

export default function Page09({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = CCMRSSyle();
	return (
		<div style={style.outerStyle()}>
			<CategoryScreen BGImage={CategoryScreenBG} titles={['Day 2 Recovery']} />
			<CourseDescription mt={true} title='Your recovery schedule' texts={['1. Stretch', 'Eat', 'Vision']} />
			<CourseDescription
				mt={true}
				title='Stretch Exercises'
				texts={[
					'Butterfly Stretch',
					'Side Lunge Stretch',
					'Standing Quad Stretch',
					'Cobra',
					'Standing Hip Flexor Stretch',
					'Standing Hamstring Stretch',
				]}
			/>
			<WarningBlock
				texts={[
					'Below is an example of a meal plan. Each Client varies. Each client’s body vaies. For custom food plans contact brugmethod@gmail.com to fit your needs. Thank you.',
				]}
				mt={true}
			/>
			<h1 className='mt-5 nice-header text-center px-3 text-black'>Sustenance</h1>
			<ItemGrid
				mt={true}
				title='Meal One (8:00-9:00)'
				rows={[['3 - Whole Eggs', '2 - Turkey Bacon', '½ cup- Rice']]}
			/>
			<ItemGrid
				mt={true}
				title='Meal Two (12:00)'
				rows={[['6oz- Ground Beef ', '1 cup - Green Bean', '½ cup - Rice']]}
			/>
			<p className='mt-5 px-3'>Snack</p>
			<p className='mt-3 px-3'>Chocolate Rice Cakes</p>
			<ItemGrid
				mt={true}
				title='Meal Three (16:00-17:00)'
				rows={[['4 - oz - Chicken Breast', '1 cup - Green Bean', '½ cup - Rice']]}
			/>
			<p className='mt-5 px-3'>
				{' '}
				Carbohydrates provide 4 calories per gram, protein provides 4 calories per gram, and fat provides 9
				calories per gram.
			</p>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
